import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { getPersonality } from 'ducks/respondent.js'
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar'

const PersonalityBar = ({ totalAnswers, totalQuestions }) => (
  <ProgressBar
    timeLabel={t`Unlimited time`}
    totalAnswers={totalAnswers}
    totalQuestions={totalQuestions}
  />
)

const mapStateToProps = state => {
  const { totalAnswers, totalQuestions } = getPersonality(state)

  return {
    totalAnswers,
    totalQuestions,
  }
}

export default connect(mapStateToProps)(PersonalityBar)
